import { useGetByHubWithHierarchySuspenseQuery } from '../../../__generated__/chirp/com/hubspot/teams/rpc/AppFatTeams.hooks';
import { useCaptureError } from '../useCaptureError';
export function useFetchTeams() {
  const {
    data,
    error
  } = useGetByHubWithHierarchySuspenseQuery({});
  useCaptureError(error, {
    message: 'Error fetching teams hierarchy'
  });
  return {
    data,
    error
  };
}